/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownLeftIcon24Solid = forwardRef('ArrowDCornerDownLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M16.5 16a4.5 4.5 0 0 0 4.5-4.5v-9a1.5 1.5 0 1 0-3 0v9a1.5 1.5 0 0 1-1.5 1.5H6.37l4.19-4.19a1.5 1.5 0 1 0-2.122-2.12l-5.503 5.503a3.263 3.263 0 0 0 0 4.614l5.503 5.504a1.5 1.5 0 0 0 2.122-2.122L6.37 16H16.5Z" })));
});
